import {Injectable} from "@angular/core";
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";


@Injectable()
export class AuthGuard implements CanActivate
{


	/**
	 * Function > constructor
	 * @param OBJ_router
	 */
	constructor(private OBJ_router: Router) {} // end function constructor


	/**
	 * Function > canActivate
	 * @param OBJ_route
	 * @param OBJ_state
	 * @return {boolean}
	 */
	canActivate(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): boolean
	{

		if (localStorage.getItem("current_user"))
		{
			// logged in so return true
			return true;
		} // end if

		// not logged in so redirect to login page with the return url
		this.OBJ_router.navigate(["/login"], {/* queryParams: { return_url: OBJ_state.url }*/});
		return false;

	} // end function canActivate


} // end function AuthGuard